<ag-task (goBackEvent)="goBackEvent.emit($event)" [isUrlMode]="isUrlMode" [selectedFeatureMode]="selectedFeatureMode"
         [sidebarEl]="featureComponentSidebarEl" [urlModeGoBackUrl]="urlModeGoBackUrl" class="full-height-container"
         id="task-component">
  <ng-template agClassifier="{{FeatureComponentMode.EDIT_ROW}}">
    <app-survey-tracker-detail
      class="task-component-detail full-height-container"></app-survey-tracker-detail>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.BULK_REQUEST_FILES}}">
    <app-survey-tracker-bulk (goBackEvent)="goBackEvent.emit($event)"
                             [featureComponentMode]="FeatureComponentMode.BULK_REQUEST_FILES"
                             [selectedRows]="selectedRows"
                             class="task-component-detail full-height-container"></app-survey-tracker-bulk>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.BULK_MAILOUT}}">
    <app-survey-tracker-bulk (goBackEvent)="goBackEvent.emit($event)"
                             [featureComponentMode]="FeatureComponentMode.BULK_MAILOUT"
                             [selectedRows]="selectedRows"
                             class="task-component-detail full-height-container"></app-survey-tracker-bulk>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.BULK_EDIT}}">
    <app-survey-tracker-bulk (goBackEvent)="goBackEvent.emit($event)"
                             [featureComponentMode]="FeatureComponentMode.BULK_EDIT"
                             [selectedRows]="selectedRows"
                             class="task-component-detail full-height-container"></app-survey-tracker-bulk>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.UPLOAD}}">
    <app-survey-tracker-bulk (goBackEvent)="goBackEvent.emit($event)"
                             [featureComponentMode]="FeatureComponentMode.UPLOAD"
                             class="task-component-detail full-height-container"></app-survey-tracker-bulk>
  </ng-template>
</ag-task>
